import { Button, Grid } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import PerfomanceCard from '../../components/PerformanceCard'

export default function ListPerfomancePage() {
    const navigation = useNavigate()
    return (
        <div style={{ margin: 40 }}>
            <Grid container rowSpacing={1} >
                <Grid xs={6}>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Button onClick={() => navigation(-1)} style={{ width: '15%', borderRadius: 10, borderWidth: 2, marginRight: 20 }} variant="outlined">
                            ย้อนกลับ
                        </Button>
                    </div>
                </Grid>
                <Grid xs={6} ></Grid>
            </Grid>
            <div style={{ marginTop: 20 }}>
                <PerfomanceCard />
                <PerfomanceCard />
            </div>
        </div>

    )
}
